exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flexParent {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-pack: space-evenly;\n      -ms-flex-pack: space-evenly;\n          justify-content: space-evenly;\n  margin-top: 2em;\n}\n\n.flexChild {\n  -webkit-box-flex: 0;\n      -ms-flex: none | [ <'flex-grow'> <'flex-shrink'>? || <'flex-basis'>];\n          flex: none | [ <'flex-grow'> <'flex-shrink'>? || <'flex-basis'>]\n}\n\n.flexChild:hover {\n  cursor: pointer;\n  opacity: .6;\n}\n\nimg {\n  width: 300px;\n  height: 400px;\n}\n\n.panel-footer {\n  text-align: center;\n  background-color: lightblue;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/functional_components/product-list/product-list.component.css
// module id = 373
// module chunks = 1